import React, { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import styled from 'styled-components';
import { WidgetArticleGalleryContent, WidgetArticleGalleryType, WidgetDisplayMode } from 'jamespot-user-api';
import { Widget, updateWidgetContent } from 'jamespot-front-business';
import { WidgetUploader } from '../components/WidgetUploader';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppDispatch, useAppSelector } from '../../../redux/store';

const JRCWidgetArticleGallery = commonComponentsRegistry.getLazyComponent('WidgetArticleGallery');
const JRCWidgetEmptyInplace = commonComponentsRegistry.getLazyComponent('WidgetEmptyInplace');
const FileViewer = commonComponentsRegistry.getLazyComponent('FileViewer');

const CSSImagePointer = styled.button`
    cursor: pointer;
`;

export const JRCWidgetArticleGalleryWrapper = ({
    widget,
    inplace,
    mode,
}: {
    widget: WidgetArticleGalleryType;
    inplace?: boolean;
    mode?: WidgetDisplayMode;
}) => {
    const { uniqid } = widget;
    const { files } = widget.content;
    const dispatch = useAppDispatch();
    const isActive = useAppSelector((state) => Widget.selectors.isActive(state, uniqid), shallowEqual);

    useEffect(() => {
        dispatch(Widget.slice.actions.setWidgetState({ uniqid, mounted: true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return files !== undefined ? (
        <>
            {mode === 'edit' ? (
                <JRCWidgetArticleGallery
                    files={files}
                    maxWidth={800}
                    gap={widget.content.gap ?? '10'}
                    column={widget.content.column ?? '3'}
                    onClick={() => undefined}
                />
            ) : (
                <FileViewer files={files} openWithOptions={[]}>
                    {(open) => {
                        return (
                            <CSSImagePointer>
                                <JRCWidgetArticleGallery
                                    files={files}
                                    maxWidth={600}
                                    gap={widget.content.gap ?? '10'}
                                    column={widget.content.column ?? '3'}
                                    onClick={(idFile) => open(idFile)}
                                />
                            </CSSImagePointer>
                        );
                    }}
                </FileViewer>
            )}
            {inplace && mode === 'edit' ? (
                <WidgetUploader
                    initialFiles={files}
                    initialClick={isActive}
                    accept={'image/png, image/jpeg, image/jpg'}
                    multiple={true}
                    onUploadSuccess={(files) => {
                        if (Array.isArray(files)) {
                            dispatch(updateWidgetContent<WidgetArticleGalleryContent>(uniqid, { files }));
                        }
                    }}
                    onUploadStart={() => {
                        dispatch(Widget.slice.actions.setWidgetState({ uniqid, loading: true }));
                    }}
                    onUploadEnd={() => {
                        dispatch(Widget.slice.actions.setWidgetState({ uniqid, loading: false }));
                    }}>
                    <JRCWidgetEmptyInplace
                        label={'WIDGET_Article_Gallery_Empty_Label'}
                        description={'WIDGET_Article_Gallery_Empty_Description'}
                        url={'widget-article-image-placeholder.png'}
                        onClick={() => undefined}
                    />
                </WidgetUploader>
            ) : (
                <></>
            )}
        </>
    ) : (
        <></>
    );
};
